/* =========================================================================
   ARTKORNERGALLERY — <akg-finish-drawer> v3
   Bandeau "Montage et encadrement".
   Données issues des variantes Shopify réelles, rendues en Liquid.
   Le prix suit la taille sélectionnée dans le sélecteur de variantes.
   ========================================================================= */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])';

  function euros(cents, compact) {
    var value = (Number(cents) || 0) / 100;
    var d = compact && value % 1 === 0 ? 0 : 2;
    return (
      '€ ' +
      value.toLocaleString('fr-FR', {
        minimumFractionDigits: d,
        maximumFractionDigits: d
      })
    );
  }

  function el(tag, className, text) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }

  function slug(s) {
    return String(s)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /* Classe une valeur de l'option "Configuration" dans l'une des 3 sections. */
  function classify(config) {
    var c = String(config).toLowerCase();
    if (c.indexOf('caisse') !== -1) return 'caisse';
    if (c.indexOf('anti-reflet') !== -1 || c.indexOf('acrylique') !== -1) return 'verre';
    return 'tirage';
  }

  function frameLabel(config) {
    var m = String(config).match(/am[eé]ricaine\s+(.+)$/i);
    return m ? m[1] : config;
  }

  function commonPrefix(list) {
    if (list.length < 2) return '';
    var p = list[0];
    for (var i = 1; i < list.length; i++) {
      var j = 0;
      while (j < p.length && j < list[i].length && p[j] === list[i][j]) j++;
      p = p.slice(0, j);
    }
    return p;
  }

  /* "…(plexi) 4 mm anti-reflet" -> "4 mm anti-reflet". */
  function shortLabel(sectionId, config, prefix, fallback) {
    if (sectionId === 'caisse') return frameLabel(config);
    var l = String(config)
      .slice(prefix.length)
      .replace(/^[\s\-–—,:()·.]+/, '')
      .trim();
    return l || fallback || config;
  }

  var AkgFinishDrawer = class extends HTMLElement {
    connectedCallback() {
      if (this.__init) return;
      this.__init = true;

      var data = this.readData();
      if (!data || !data.variants || !data.variants.length) return;

      this.raw = data;
      this.sizePos = data.sizePos || 0;
      this.configPos = data.configPos != null ? data.configPos : 1;
      this.optionImages = data.optionImages || {};
      this.triggerLabel = this.dataset.triggerLabel || 'Finition';

      this.sections = this.buildSections(data);
      if (!this.sections.length) return;

      this.sizes = [];
      var self = this;
      data.variants.forEach(function (v) {
        var s = v.opts[self.sizePos];
        if (self.sizes.indexOf(s) === -1) self.sizes.push(s);
      });

      var def = this.dataset.defaultSection || 'tirage';
      var hasDef = this.sections.some(function (s) {
        return s.id === def;
      });

      this.state = {
        isOpen: false,
        size: this.currentSize() || this.sizes[0],
        selectedSection: hasDef ? def : this.sections[this.sections.length - 1].id,
        selectedOption: {},
        variantsOpen: {}
      };

      this.sections.forEach(function (s) {
        self.state.selectedOption[s.id] = s.options[0].id;
        self.state.variantsOpen[s.id] = false;
      });

      this.build();
      this.watchForm();
      this.render();
    }

    readData() {
      var script = this.querySelector('script[data-finish-options]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        console.warn('[akg-finish-drawer] JSON invalide', e);
        return null;
      }
    }

    buildSections(data) {
      var self = this;
      var meta = {};
      (data.sections || []).forEach(function (m) {
        meta[m.id] = m;
      });

      /* 1er passage : regroupement par section puis par configuration. */
      var groups = {};
      var index = {};

      data.variants.forEach(function (v) {
        var size = v.opts[self.sizePos];
        var config = v.opts[self.configPos];
        var sid = classify(config);

        groups[sid] = groups[sid] || [];
        index[sid] = index[sid] || {};
        if (!index[sid][config]) {
          index[sid][config] = { config: config, bySize: {} };
          groups[sid].push(index[sid][config]);
        }
        index[sid][config].bySize[size] = v;
      });

      /* 2e passage : libellés courts, calculés sur le préfixe commun. */
      return ['caisse', 'verre', 'tirage']
        .filter(function (sid) {
          return groups[sid];
        })
        .map(function (sid) {
          var m = meta[sid] || {};
          var entries = groups[sid];
          var prefix = commonPrefix(
            entries.map(function (e) {
              return e.config;
            })
          );

          var options = entries.map(function (e) {
            var label = shortLabel(sid, e.config, prefix, m.baseLabel);
            var oid = slug(label);
            return {
              id: oid,
              label: label,
              config: e.config,
              bySize: e.bySize,
              img: self.optionImages[oid] || m.img || ''
            };
          });

          return {
            id: sid,
            title: m.title || sid,
            desc: m.desc || '',
            variantHeading: options.length > 1 ? m.variantHeading || null : null,
            img: m.img || '',
            options: options
          };
        });
    }

    productForm() {
      return (
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('product-form form')
      );
    }

    currentSize() {
      var form = this.productForm();
      if (!form) return null;
      var input = form.querySelector('input[name="id"]');
      if (!input || !input.value) return null;
      var id = String(input.value);
      var self = this;
      var hit = this.raw.variants.filter(function (v) {
        return String(v.id) === id;
      })[0];
      return hit ? hit.opts[self.sizePos] : null;
    }

    watchForm() {
      var form = this.productForm();
      if (!form) return;
      var self = this;
      var sync = function () {
        var size = self.currentSize();
        if (size && size !== self.state.size) {
          self.state.size = size;
          self.applied = false;
          self.render();
        }
      };
      form.addEventListener('change', sync);
      form.addEventListener('click', function () {
        window.setTimeout(sync, 60);
      });
    }

    section(id) {
      return this.sections.filter(function (s) {
        return s.id === id;
      })[0];
    }

    optionOf(section) {
      var cur = this.state.selectedOption[section.id];
      return (
        section.options.filter(function (o) {
          return o.id === cur;
        })[0] || section.options[0]
      );
    }

    variantFor(section, option) {
      return option.bySize[this.state.size] || null;
    }

    priceOf(section, option) {
      var v = this.variantFor(section, option);
      return v ? v.price : null;
    }

    oldPriceOf(section, option) {
      var v = this.variantFor(section, option);
      return v && v.oldPrice ? v.oldPrice : null;
    }

    build() {
      var self = this;

      this.triggerEl = this.querySelector('[data-akg-fd-trigger]');
      this.triggerPriceEl = this.querySelector('[data-akg-fd-trigger-price]');
      if (this.triggerEl) {
        this.triggerEl.addEventListener('click', function () {
          self.open();
        });
      }

      this.scrim = el('div', 'akg-fd-scrim');
      this.scrim.setAttribute('hidden', '');
      this.scrim.addEventListener('click', function () {
        self.close();
      });

      this.drawer = el('div', 'akg-fd-drawer');
      this.drawer.setAttribute('role', 'dialog');
      this.drawer.setAttribute('aria-modal', 'true');
      this.drawer.setAttribute('aria-label', 'Montage et encadrement');
      this.drawer.setAttribute('hidden', '');

      var header = el('div', 'akg-fd-drawer__header');
      header.appendChild(el('h2', 'akg-fd-drawer__title', 'Montage et encadrement'));
      var close = el('button', 'akg-fd-drawer__close', '✕');
      close.type = 'button';
      close.setAttribute('aria-label', 'Fermer');
      close.addEventListener('click', function () {
        self.close();
      });
      header.appendChild(close);

      this.body = el('div', 'akg-fd-drawer__body');
      this.sizeNote = el('p', 'akg-fd-drawer__size-note');
      this.body.appendChild(this.sizeNote);

      this.radiogroup = el('div', 'akg-fd-drawer__cards');
      this.radiogroup.setAttribute('role', 'radiogroup');
      this.radiogroup.setAttribute('aria-label', 'Type de finition');
      this.body.appendChild(this.radiogroup);

      this.cards = {};
      this.sections.forEach(function (s) {
        self.radiogroup.appendChild(self.buildCard(s));
      });

      this.body.appendChild(
        el(
          'p',
          'akg-fd-drawer__legal',
          'PICTO - Les finitions personnalisées sont réalisées sur commande dans notre atelier'
        )
      );

      var footer = el('div', 'akg-fd-drawer__footer');
      var col = el('div', 'akg-fd-drawer__total-col');
      col.appendChild(el('p', 'akg-fd-drawer__total-label', 'Total TTC'));
      var row = el('div', 'akg-fd-drawer__total-row');
      this.totalEl = el('span', 'akg-fd-drawer__total');
      this.totalOldEl = el('span', 'akg-fd-drawer__total-old');
      row.appendChild(this.totalEl);
      row.appendChild(this.totalOldEl);
      col.appendChild(row);

      this.applyBtn = el('button', 'akg-fd-drawer__apply', 'Appliquer');
      this.applyBtn.type = 'button';
      this.applyBtn.addEventListener('click', function () {
        self.apply();
      });

      footer.appendChild(col);
      footer.appendChild(this.applyBtn);

      this.drawer.appendChild(header);
      this.drawer.appendChild(this.body);
      this.drawer.appendChild(footer);

      document.body.appendChild(this.scrim);
      document.body.appendChild(this.drawer);

      this.onKeydown = this.onKeydown.bind(this);
    }

    buildCard(section) {
      var self = this;
      var refs = { section: section };

      var card = el('div', 'akg-fd-card');
      card.setAttribute('role', 'radio');
      card.setAttribute('tabindex', '0');
      card.addEventListener('click', function () {
        self.state.selectedSection = section.id;
        self.render();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          self.state.selectedSection = section.id;
          self.render();
        }
      });

      var media = el('div', 'akg-fd-card__media');
      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
      refs.img = img;
      refs.media = media;
      refs.badge = el('span', 'akg-fd-card__badge', 'Sélectionné');
      media.appendChild(refs.badge);
      card.appendChild(media);

      /* Repli si aucune photo de finition n'est configuree. */
      refs.badgeInline = el(
        'span',
        'akg-fd-card__badge akg-fd-card__badge--inline',
        refs.badge.textContent
      );
      card.appendChild(refs.badgeInline);

      var body = el('div', 'akg-fd-card__body');
      var head = el('div', 'akg-fd-card__head');
      head.appendChild(el('h3', 'akg-fd-card__title', section.title));
      var prices = el('div', 'akg-fd-card__prices');
      refs.price = el('span', 'akg-fd-card__price');
      refs.oldPrice = el('span', 'akg-fd-card__price-old');
      prices.appendChild(refs.price);
      prices.appendChild(refs.oldPrice);
      head.appendChild(prices);
      body.appendChild(head);

      if (section.desc) {
        body.appendChild(el('p', 'akg-fd-card__desc', section.desc));
      }

      if (section.variantHeading) {
        body.appendChild(el('div', 'akg-fd-card__rule'));

        /* La section "caisse" (Caisse américaine) affiche directement ses
           options ("Autres couleurs de cadre"), sans accordéon à déplier. */
        var useAccordion = section.id !== 'caisse';

        if (useAccordion) {
          var acc = el('button', 'akg-fd-card__accordion');
          acc.type = 'button';
          acc.setAttribute('aria-expanded', 'false');
          acc.appendChild(
            el('span', 'akg-fd-card__accordion-label', section.variantHeading)
          );
          var chev = el('span', 'akg-fd-card__accordion-chevron', '▾');
          chev.setAttribute('aria-hidden', 'true');
          acc.appendChild(chev);
          acc.addEventListener('click', function (e) {
            e.stopPropagation();
            self.state.variantsOpen[section.id] = !self.state.variantsOpen[section.id];
            self.render();
          });
          body.appendChild(acc);
          refs.accordion = acc;
        } else {
          body.appendChild(
            el(
              'p',
              'akg-fd-card__accordion-label akg-fd-card__static-heading',
              section.variantHeading
            )
          );
        }

        var opts = el('div', 'akg-fd-card__options');
        opts.style.display = useAccordion ? 'none' : '';
        refs.optionEls = {};

        section.options.forEach(function (option) {
          var chip = el('div', 'akg-fd-opt');
          chip.setAttribute('role', 'radio');
          chip.setAttribute('tabindex', '0');

          if (option.img) {
            var t = document.createElement('img');
            t.className = 'akg-fd-opt__thumb';
            t.setAttribute('src', option.img);
            t.alt = '';
            t.loading = 'lazy';
            chip.appendChild(t);
          }

          chip.appendChild(el('span', 'akg-fd-opt__label', option.label));
          var delta = el('span', 'akg-fd-opt__delta');
          chip.appendChild(delta);

          var pick = function (e) {
            e.stopPropagation();
            if (chip.classList.contains('is-unavailable')) return;
            self.state.selectedOption[section.id] = option.id;
            self.state.selectedSection = section.id;
            self.render();
          };
          chip.addEventListener('click', pick);
          chip.addEventListener('keydown', function (e) {
            if (e.key === ' ' || e.key === 'Enter') {
              e.preventDefault();
              pick(e);
            }
          });

          opts.appendChild(chip);
          refs.optionEls[option.id] = { chip: chip, delta: delta };
        });

        body.appendChild(opts);
        refs.options = opts;
      }

      card.appendChild(body);
      refs.card = card;
      this.cards[section.id] = refs;
      return card;
    }

    /* Grise/desactive dans le SELECTEUR DE TAILLE natif (boutons hors du
       tiroir) les tailles qui n'existent pas pour la finition actuellement
       selectionnee dans le tiroir (ex: 208x117 n'existe qu'en "Tirage
       simple", pas avec une caisse americaine). Pilote en JS car ces
       donnees viennent de notre propre JSON, pas de Shopify (value.available
       n'est pas fiable ici, l'option "Configuration" etant geree par un
       select cache hors du flux standard). */
    syncSizeButtons() {
      var form = this.productForm();
      if (!form) return;

      var active = this.section(this.state.selectedSection);
      var option = this.optionOf(active);
      var bySize = (option && option.bySize) || {};

      var radios = form.querySelectorAll('.akg-variant-btn input[type="radio"]');
      radios.forEach(function (radio) {
        var wrap = radio.closest('.akg-variant-btn');
        if (!wrap) return;
        var available = Object.prototype.hasOwnProperty.call(bySize, radio.value);
        wrap.classList.toggle('akg-variant-btn--unavailable', !available);
        radio.disabled = !available;
      });
    }

    render() {
      var self = this;
      this.sizeNote.textContent = 'Format sélectionné : ' + this.state.size;

      this.sections.forEach(function (section) {
        var refs = self.cards[section.id];
        var isSel = self.state.selectedSection === section.id;
        var isOpen = !!self.state.variantsOpen[section.id];
        var option = self.optionOf(section);

        refs.card.setAttribute('aria-checked', isSel ? 'true' : 'false');

        var price = self.priceOf(section, option);
        var old = self.oldPriceOf(section, option);

        refs.price.textContent = price != null ? euros(price) : 'Indisponible';
        refs.oldPrice.textContent = old ? euros(old) : '';
        refs.oldPrice.style.display = old ? '' : 'none';

        /* Pas de source valide : on retire l'attribut, sinon icone cassee. */
        var src = option.img || section.img || '';
        if (src) {
          if (refs.img.getAttribute('src') !== src) refs.img.setAttribute('src', src);
        } else {
          refs.img.removeAttribute('src');
        }
        refs.media.style.display = src ? '' : 'none';
        refs.badge.style.display = isSel && src ? '' : 'none';
        refs.badgeInline.style.display = isSel && !src ? '' : 'none';

        if (refs.accordion) {
          refs.accordion.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          refs.options.style.display = isSel && isOpen ? '' : 'none';
        }
        /* Les sections sans accordéon (ex. "caisse") restent toujours
           dépliées, que la carte soit sélectionnée ou non. */

        if (refs.optionEls) {
          var base = self.priceOf(section, section.options[0]);
          section.options.forEach(function (o) {
            var r = refs.optionEls[o.id];
            var variantForO = self.variantFor(section, o);
            var isUnavailable = !variantForO;

            r.chip.classList.toggle('is-unavailable', isUnavailable);
            r.chip.setAttribute('aria-disabled', isUnavailable ? 'true' : 'false');
            r.chip.setAttribute(
              'aria-checked',
              self.state.selectedOption[section.id] === o.id ? 'true' : 'false'
            );

            if (isUnavailable) {
              r.delta.textContent = 'Indisponible';
            } else {
              var p = self.priceOf(section, o);
              var d = p != null && base != null ? p - base : 0;
              r.delta.textContent = d > 0 ? '+ ' + euros(d, true) : '';
            }
          });
        }
      });

      var active = this.section(this.state.selectedSection);
      var activeOpt = this.optionOf(active);
      var total = this.priceOf(active, activeOpt);
      var totalOld = this.oldPriceOf(active, activeOpt);
      var variant = this.variantFor(active, activeOpt);

      this.totalEl.textContent = total != null ? euros(total) : '—';
      this.totalOldEl.textContent = totalOld ? euros(totalOld) : '';
      this.totalOldEl.style.display = totalOld ? '' : 'none';

      this.applyBtn.disabled = !variant;

      if (this.triggerPriceEl && !this.applied && total != null) {
        this.triggerPriceEl.textContent = euros(total);
      }

      this.syncSizeButtons();
    }

    open() {
      if (this.state.isOpen) return;
      this.state.isOpen = true;
      this.lastFocus = document.activeElement;
      this.scrim.hidden = false;
      this.drawer.hidden = false;
      void this.drawer.offsetWidth;
      this.scrim.classList.add('is-open');
      this.drawer.classList.add('is-open');
      document.body.classList.add('akg-fd-locked');
      document.addEventListener('keydown', this.onKeydown);
      var f = this.drawer.querySelector(FOCUSABLE);
      if (f) f.focus();
    }

    close() {
      if (!this.state.isOpen) return;
      this.state.isOpen = false;
      this.scrim.classList.remove('is-open');
      this.drawer.classList.remove('is-open');
      document.body.classList.remove('akg-fd-locked');
      document.removeEventListener('keydown', this.onKeydown);
      var self = this;
      window.setTimeout(function () {
        if (!self.state.isOpen) {
          self.drawer.hidden = true;
          self.scrim.hidden = true;
        }
      }, 400);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
        return;
      }
      if (e.key !== 'Tab') return;
      var nodes = Array.prototype.filter.call(
        this.drawer.querySelectorAll(FOCUSABLE),
        function (n) {
          return n.offsetParent !== null && !n.disabled;
        }
      );
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    apply() {
      var section = this.section(this.state.selectedSection);
      var option = this.optionOf(section);
      var variant = this.variantFor(section, option);
      if (!variant) return;

      var form = this.productForm();
      if (form) {
        /* On ne synchronise QUE le select "Configuration" (mecanisme
           officiel de variant-picker.js). Le champ cache input[name="id"]
           est ensuite recalcule et remplace automatiquement par
           variant-picker.js suite a sa propre requete serveur.
           Auparavant on mettait aussi a jour input[name="id"] manuellement
           avec son propre evenement "change" : cela declenchait DEUX
           requetes concurrentes (une pour l'input, une pour le select),
           et selon l'ordre de reponse le bouton "Ajouter au panier"
           pouvait rester bloque en desactive. */
        var config = option.config;
        var synced = false;

        form.querySelectorAll('input[type="radio"], select').forEach(function (node) {
          if (node.tagName === 'SELECT') {
            Array.prototype.forEach.call(node.options, function (o) {
              if (o.value === config) {
                node.value = config;
                node.dispatchEvent(new Event('change', { bubbles: true }));
                synced = true;
              }
            });
          } else if (node.value === config) {
            if (!node.checked) {
              node.checked = true;
              node.dispatchEvent(new Event('change', { bubbles: true }));
            }
            synced = true;
          }
        });

        /* Repli : si aucun select/radio ne correspond (cas improbable),
           on met a jour l'input id directement, sans dispatch, pour ne
           pas entrer en conflit avec variant-picker.js. */
        if (!synced) {
          var input = form.querySelector('input[name="id"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'id';
            form.appendChild(input);
          }
          input.value = String(variant.id);
        }
      }

      this.applied = true;
      var labelEl = this.querySelector('[data-akg-fd-trigger-label]');
      if (labelEl) labelEl.textContent = section.title;
      if (this.triggerPriceEl) this.triggerPriceEl.textContent = euros(variant.price);

      this.dispatchEvent(
        new CustomEvent('akg:finish-applied', {
          bubbles: true,
          detail: {
            sectionId: section.id,
            optionId: option.id,
            config: option.config,
            size: this.state.size,
            variantId: variant.id,
            price: variant.price
          }
        })
      );

      this.close();
    }
  };

  if (!window.customElements.get('akg-finish-drawer')) {
    window.customElements.define('akg-finish-drawer', AkgFinishDrawer);
  }
})();
